import classNames from 'classnames';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useLabels } from '../../contexts/LabelsContext';
import Blocks from '../blocks/Blocks';
import StyledButton from '../buttons/StyledButton';
import HelpModal from './HelpModal';

import styles from '../../../styles/modals/explanation-modal.module.css';

interface PincodeEntryModalProps {
    blocks?: Block[];
    quantity: number;
    onClose?: () => void;
    withoutButtons?: boolean;
}

const PincodeEntryModal: React.FC<PincodeEntryModalProps> = ({
    blocks = null,
    quantity,
    onClose = null,
    withoutButtons = false,
}) => {
    const { pincodeEntryModalCloseButton = null } = useLabels();
    const finalBlocks = useMemo(
        () =>
            (blocks || []).map((block) =>
                block.type === 'quantity'
                    ? {
                          type: 'text',
                          body: `<div class="${styles.quantity}">+${quantity}</div>`,
                      }
                    : block,
            ),
        [blocks],
    );
    return (
        <HelpModal
            className={classNames([styles.container, 'modal-pincode-entry'])}
            onClose={onClose}
            withCloseButton={withoutButtons}
        >
            <Blocks blocks={finalBlocks || []} />
            {!withoutButtons ? (
                <div className={styles.buttons}>
                    {onClose !== null ? (
                        <StyledButton
                            className={classNames(styles.button, 'button-close')}
                            colored
                            onClick={onClose}
                        >
                            {pincodeEntryModalCloseButton || (
                                <FormattedMessage
                                    defaultMessage="Close"
                                    description="Button label"
                                />
                            )}
                        </StyledButton>
                    ) : null}
                </div>
            ) : null}
        </HelpModal>
    );
};

export default PincodeEntryModal;
